var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "89", height: "173", fill: "none", viewBox: "0 0 89 173" }, props),
    React.createElement(
      "g",
      { opacity: ".4" },
      React.createElement(
        "mask",
        { id: "b", width: "89", height: "173", x: "0", y: "0", maskUnits: "userSpaceOnUse" },
        React.createElement("path", { fill: "url(#a)", d: "M0 0h173v88.31H0z", transform: "matrix(0 -1 -1 0 88.31 173)" })
      ),
      React.createElement(
        "g",
        { fill: "#3AAE97", mask: "url(#b)" },
        React.createElement("path", { d: "M88.31 171.79c46.45 0 84.1-37.1 84.1-82.87S134.76 6.05 88.31 6.05c-46.44 0-84.1 37.1-84.1 82.87s37.66 82.87 84.1 82.87z", opacity: ".12" }),
        React.createElement("path", { d: "M88.31 171.79c34.84 0 63.08-27.83 63.08-62.15 0-34.33-28.24-62.16-63.08-62.16s-63.07 27.83-63.07 62.16c0 34.32 28.24 62.15 63.07 62.15z", opacity: ".12" }),
        React.createElement("path", { d: "M88.31 171.8c23.23 0 42.05-18.56 42.05-41.45s-18.82-41.43-42.05-41.43c-23.22 0-42.05 18.55-42.05 41.44 0 22.88 18.83 41.43 42.05 41.43z", opacity: ".12" })
      )
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "linearGradient",
        { id: "a", x1: "-59.51", x2: "-5.19", y1: "38.06", y2: "149.44", gradientUnits: "userSpaceOnUse" },
        React.createElement("stop", { stopColor: "#48C993" }),
        React.createElement("stop", { offset: "1", stopColor: "#3AAE97" })
      )
    )
  );
});